const actions = {
    FETCH_PROVIDENT_FUND_EMPLOYEES: 'FETCH_PROVIDENT_FUND_EMPLOYEES',

    fetchProvidentFundEmployeesAction: (data) => {
        return {
            type: actions.FETCH_PROVIDENT_FUND_EMPLOYEES,
            data
        };
    },
};

export default actions;

